"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InvitacionAReservar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className="bg-light-background py-20 px-6 text-center">
      <div className={`mx-auto max-w-2xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <p className="mb-6 text-lg font-medium text-foreground-light">
          Da el primer paso hacia la claridad que buscas
        </p>
        <Link to="/ContactReserveSessionPage">
          <Button size="lg" className="shadow-medium hover:-translate-y-0.5 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">Reserva tu sesión gratuita</Button>
        </Link>
      </div>
    </section>;
}